import { render } from "./shop.vue?vue&type=template&id=2c5ea974"
import script from "./shop.vue?vue&type=script&lang=js"
export * from "./shop.vue?vue&type=script&lang=js"

import "./shop.vue?vue&type=style&index=0&id=2c5ea974&lang=scss"

import exportComponent from "/Users/demigodliu/src/packages/cumen/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__